<template>
  <v-container fluid class="b-container">
    <v-sheet class="pa-3">
      <v-row no-gutters align="center" class="pa-5 pt-0 pb-8 mb-8">
        <v-col cols="auto">
          <v-img src="@/assets/star_cup.png" width="60" height="60"></v-img>
        </v-col>

        <v-col cols="8" class="pl-5">
          <h4 v-text="translations.title[lang]"></h4>
          <div
            style="font-size: 0.875rem"
            class="font-weight-medium mt-1"
            v-text="translations.info[lang]"
          ></div>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="stores"
        :footer-props="{
          itemsPerPageOptions: [12],
          showCurrentPage: true,
          pageText: `${page * 12 - 11}-${
            page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
          } ${translations.paginationText[lang]} ${serverItemsLength}`,
        }"
        :server-items-length="serverItemsLength"
        :page.sync="page"
        :loading="loading"
        class="b-outlined mt-8"
      >
        <template v-slot:item.name="{ item }">
          {{ item.name }}
          <v-icon v-text="icons.mdiLaunch" style="cursor: pointer"></v-icon>
        </template>

        <template v-slot:item.attribution_settings>
          <v-btn
            color="secondary"
            class="text-capitalize px-5"
            depressed
            v-text="translations.change[lang]"
            @click="attributionDialog = true"
          ></v-btn>
        </template>

        <template v-slot:item.device_settings>
          <v-btn
            color="secondary"
            class="text-capitalize px-5"
            depressed
            v-text="translations.change[lang]"
            @click="deviceDialog = true"
          ></v-btn>
        </template>

        <template v-slot:item.mobile_payments>
          <v-btn
            color="secondary"
            class="text-capitalize px-5"
            depressed
            v-text="translations.change[lang]"
            @click="paymentsDialog = true"
          ></v-btn>
        </template>

        <template v-slot:item.orders>
          <v-btn
            color="secondary"
            class="text-capitalize px-5"
            depressed
            v-text="translations.change[lang]"
            @click="ordersDialog = true"
          ></v-btn>
        </template>

        <template v-slot:item.receipt_scanning>
          <v-btn
            color="secondary"
            class="text-capitalize px-5"
            depressed
            v-text="translations.change[lang]"
            @click="scanningDialog = true"
          ></v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="deviceDialog" max-width="500">
        <PointDelivery @cancel="deviceDialog = false" />
      </v-dialog>

      <v-dialog v-model="paymentsDialog" max-width="500">
        <MobilePayments @cancel="paymentsDialog = false" />
      </v-dialog>

      <v-dialog v-model="attributionDialog" max-width="500">
        <SendPoints @cancel="attributionDialog = false" />
      </v-dialog>

      <v-dialog v-model="scanningDialog" max-width="500">
        <ScanReceipt @cancel="scanningDialog = false" />
      </v-dialog>

      <v-dialog v-model="ordersDialog" max-width="500">
        <DeliverySettings @cancel="ordersDialog = false" />
      </v-dialog>
    </v-sheet>
  </v-container>
</template>

<script>
import { mdiLaunch } from '@mdi/js';
import DeliverySettings from '@/components/storePanel/settings/reward/DeliverySettings.vue';
import ScanReceipt from '@/components/storePanel/settings/reward/ScanReceipt.vue';
import SendPoints from '@/components/storePanel/settings/reward/SendPoints.vue';
import MobilePayments from '@/components/storePanel/settings/reward/MobilePayments.vue';
import PointDelivery from '@/components/storePanel/settings/reward/PointDelivery.vue';
import translations from '@/utils/translations/loyaltyPanel/reward';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Reward',

  mixins: [translations],

  components: {
    DeliverySettings,
    ScanReceipt,
    SendPoints,
    MobilePayments,
    PointDelivery,
  },

  data() {
    return {
      icons: { mdiLaunch },
      page: +this.$route.query.page,
      attributionTypes: [
        {
          name: 'Per Amount',
          value: 1,
        },
        {
          name: 'Per Product',
          value: 2,
        },
      ],
      scanningDialog: false,
      ordersDialog: false,
      attributionDialog: false,
      paymentsDialog: false,
      deviceDialog: false,
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'serverItemsLength']),
    ...mapState('loyaltyPanel/stores/storesTab', ['stores']),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    headers() {
      return [
        {
          text: this.translations.name[this.lang],
          value: 'name',
        },
        {
          text: this.translations[`${this.storeMode}AttributionSettings`][this.lang],
          value: 'attribution_settings',
        },
        {
          text: this.translations.orders[this.lang],
          value: 'orders',
        },
        {
          text: this.translations.IoTDeviceSettings[this.lang],
          value: 'device_settings',
        },
        {
          text: this.translations.mobilePayments[this.lang],
          value: 'mobile_payments',
        },
        {
          text: this.translations.receiptScanning[this.lang],
          value: 'receipt_scanning',
        },
      ];
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  watch: {
    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.getItems(this.query);
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  mounted() {
    this.getItems(this.query);
  },

  methods: {
    ...mapActions('loyaltyPanel/stores/storesTab', ['getItems']),
  },
};
</script>
